import Head from "next/head";
import { useTranslation } from "@/components/useTranslation";

export default function Impressum() {

    const t = useTranslation();

    return (
        <>
            <Head>
                <title> Funfsterne | {t.impressum} </title>
            </Head>
            <div className='max-w-6xl mx-auto py-32 md:px-8 sub-page-content'>
                <div className="relative w-full ">
                    <div className="relative">
                        <div className="flex items-start justify-between p-4 border-b rounded-t">
                            <h1 className="text-3xl font-semibold text-gray-900"> {t.impressum} </h1>
                        </div>
                        <div className="p-6 space-y-6">
                            <div className="modal-inner">
                                <div className="py-3">
                                    <h6 className="py-3">Funfsterne</h6>
                                    <p className="m-0">MH Marketing GmbH
                                        <br />
                                        Kurfürstendamm 45, 10707 Berlin Deutschland <br />
                                        Geschäftsführer: Markus Hene</p>
                                </div>
                                <div className="py-3">
                                    <h6>Kontakt:</h6>
                                    <p className="m-0">E-Mail: <a href="mailto:info@Funfsterne.com" style={{ "fontSize": "0.8rem", "letterSpacing": "1.2", "color": "#444444" }}>info@funfsterne.de</a></p>
                                    <p className="m-0">Telefonnummer: +49 30 200 09 515</p>
                                </div>
                                <div className="py-3">
                                    <h6>{t.impressum_step1_title}</h6>
                                    <p>{t.impressum_step1_description}</p>
                                </div>
                                <div className="py-3">
                                    <h6>{t.impressum_step2_title}</h6>
                                    <p>{t.impressum_step2_description}</p>
                                </div>
                                <div className="py-3">
                                    <h6>{t.impressum_step3_title}</h6>
                                    <p>{t.impressum_step3_description}</p>
                                </div>
                                <div className="py-3">
                                    <h6>{t.impressum_step4_title}</h6>
                                    <p>{t.impressum_step4_description}</p>
                                </div>
                                <div className="py-3">
                                    <h6>{t.impressum_step5_title}</h6>
                                    <p>{t.impressum_step5_description}</p>
                                </div>
                                <div className="py-3">
                                    <h6>{t.impressum_step6_title}</h6>
                                    <p>{t.impressum_step6_description}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}